import { ensureSegmentScriptCrossOrigin } from "@/domains/metrics/segment-utils";
import { clientEnvModule } from "@/modules/client-env";
import { IS_VARIANT_DEPLOYMENT } from "@/modules/global-state/isVariantDeployment";
import { AnalyticsBrowser } from "@segment/analytics-next";

ensureSegmentScriptCrossOrigin();

/**
 * No-op analytics instance for variant deployments.
 * All methods are stubs that do nothing.
 */
const createNoOpAnalyticsInstance = () => {
  const noOp = () => Promise.resolve();
  return {
    identify: noOp,
    track: noOp,
    page: noOp,
    group: noOp,
    alias: noOp,
    reset: noOp,
    setAnonymousId: noOp,
  } as unknown as AnalyticsBrowser;
};

export const segmentAnalyticsInstance = (() => {
  let instance: AnalyticsBrowser;

  return () => {
    if (instance) return instance;

    // Skip Segment for variant deployments (e.g., solstice)
    if (IS_VARIANT_DEPLOYMENT) {
      instance = createNoOpAnalyticsInstance();
      return instance;
    }

    const writeKey = clientEnvModule.isDesktop()
      ? import.meta.env.VITE_DESKTOP_SEGMENT_WRITE_KEY
      : import.meta.env.VITE_SEGMENT_WRITE_KEY;

    instance = AnalyticsBrowser.load({
      writeKey,
    });

    return instance;
  };
})();
